<template>
  <div>
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>

    <v-dialog v-model="dialog" width="500" persistent>
      <v-card>
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark :color="titleColor">
            <v-toolbar-title>{{ title }}</v-toolbar-title>
          </v-toolbar>
        </v-flex>

        <v-card-text>
          <blockquote>{{ message }}</blockquote>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="dialog = false"> Kapat </v-btn>
          <v-btn color="primary" v-if="mailVisible" flat @click="sendMail()">
            Arkman'a Mail At
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import auth from "@/api/auth.js";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";

export default {
  props: ["value"],
  methods: {
    open(value) {
      //data.type 1 = error , 2 = warning
      this.data = value;
      this.dialog = true;
      this.message = value.message;
      switch (value.type) {
        case 1:
          this.title = "Hata";
          this.titleColor = "error";
          this.type = value.type;
          break;
        case 2:
          this.title = this.$t('Warning');
          this.titleColor = "warning";
          this.type = value.type;
          this.mailVisible = false;
      }
    },
    sendMail() {
      let formData = new FormData();

      formData.append("Konu", "Arkman Next Dialog Hata E-mail");
      formData.append("to", "logcontrol@arkman.com.tr");
      formData.append("mailType", "0");
      let msg1 = JSON.stringify(this.data);
      var jsonPretty = JSON.stringify(JSON.parse(msg1),null,2);  

      formData.append("formattedMessage", jsonPretty);

      axios.defaults.baseURL = auth.API_URL;

      let credentials = JSON.parse(window.localStorage.getItem("credentials"));

      axios.defaults.headers.post["Content-Type"] = "multipart/form-data";
      axios
        .post(auth.API_URL + "api/Helpers/SendEmailWithError", formData, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
            CariSirketNo: credentials.SirketKodu.toString(),
            CoperSirketNo: credentials.CoperSirketNo.toString(),
          },
        })
        .then((response) => {
          if (response.data == true) {
            this.text1 = "Mail Gönderildi.";
            this.snackbar = true;
          } else {
            this.text1 = this.$t("Mail-system-not-right-now-send-manual-mail");
            this.snackbar = true;
          }
        })
        .catch((error) => {
          this.text1 = this.$t("Mail-system-not-right-now-send-manual-mail");
          this.snackbar = true;
        });
      this.dialog = false;
    },
    htmlEncode: function (str) {
      str = str.replace(/&/g, ".....");
      str = str.replace(/"/g, "_____");
      str = str.replace(/</g, "-----");
      str = str.replace(/>/g, "+++++");
      return str;
    },
  },
  components: {
    snackbarcomp,
  },
  data() {
    return {
      mailVisible: true,
      data: {},
      title: null,
      dialog: false,
      message: null,
      titleColor: null,
      type: 0,
      text1: null,
      snackbar: false,
    };
  },
};
</script>

<style>
</style>